import React, { useState } from "react";
import FormArbeid from "../forms/FormArbeid";
import useHttp from "../hooks/use-http";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import "./NieuweCheckWH.css";

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NieuweCheckArbeid = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();

    const [inputData, setInputData] = useState({
      name: user?.name || "",
      email: user?.email || "",
      hasTerms: false,
      language: "nl",
      hasStrikethrough: "NO",
      isScanned: "NO",
      agreed: false,
      disclaimerAgreed: false,
      contractFile: null,
      termsFile: null,
      accessCode: "",
    });


    const {
      sendRequest: startRunRequest,
      isLoading: startRunLoading,
      error: startRunError,
    } = useHttp();
  
    function startRun() {
      const formData = new FormData();
  
      formData.append("name", inputData.name);
      formData.append("email", inputData.email);
      formData.append("has_terms", inputData.hasTerms);
      formData.append("language", inputData.language);
      formData.append("has_strikethrough", inputData.hasStrikethrough);
      formData.append("is_scanned", inputData.isScanned);
      formData.append("agreed_disclaimer", inputData.agreed);
      formData.append("contract_file", inputData.contractFile);
      formData.append("access_code", inputData.accessCode);
  
      if (inputData.termsFile !== null) {
        formData.append("terms_file", inputData.termsFile);
      }
  
      function applyData(res) {
        navigate("/");
      }
  
      startRunRequest(
        {
          url: `${REACT_APP_BACKEND_URL}/run/start_labour-contract`,
          method: "POST",
          body: formData,
          isFileUpload: true,
        },
        applyData
      );
    }

  return (
    <div className="nc-container">
      <FormArbeid
        startRun={startRun}
        runLoading={startRunLoading}
        runError={startRunError}
        inputData={inputData}
        setInputData={setInputData}
      />
    </div>
  );
};

export default NieuweCheckArbeid;
